module.exports = __webpack_public_path__ + "static/media/umang_sakhare.910f16fe.jpg";